import EnterViewAnimate from '@/components/enterView/animate'
import IconArrowDouble from '@icon/variable/arrow-double.svg'
import { cn } from '@utils'

export function ModuleName({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <EnterViewAnimate
      animate='animate__fadeInDown'
      className={cn('font-bold text-sm text-primary uppercase ', className)}
    >
      {children}
      <IconArrowDouble className='inline-block ml-1 fill-current -translate-y-0.25' />
    </EnterViewAnimate>
  )
}

export function ModuleTitle({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <EnterViewAnimate
      animate='animate__fadeInDown'
      className={cn('text-3xl lg:text-5xl font-bold', className)}
    >
      <h2>{children}</h2>
    </EnterViewAnimate>
  )
}
